import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getAdvanced } from '../../utils';
export default ((node, props) => {
  var forms = node.querySelectorAll('[data-product-sku]');
  var carouselConfig = {};
  if (props.appearance === 'carousel') {
    carouselConfig = {
      autoplay: node.getAttribute('data-autoplay') === 'true',
      autoplaySpeed: parseInt(node.getAttribute('data-autoplay-speed')),
      infinite: node.getAttribute('data-infinite-loop') === 'true',
      arrows: node.getAttribute('data-show-arrows') === 'true',
      dots: node.getAttribute('data-show-dots') === 'true',
      carouselMode: node.getAttribute('data-carousel-mode'),
      centerPadding: node.getAttribute('data-center-padding')
    };
  }
  return _objectSpread(_objectSpread({
    skus: [...forms].map(form => form.getAttribute('data-product-sku'))
  }, carouselConfig), getAdvanced(node));
});